
import { ref, computed, defineComponent, getCurrentInstance } from "vue-demi";
import { SMNotifications, SMUser } from "@/store";

export default defineComponent({
  name: "Toast",

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },

  emits: ["update:modelValue", "cancel", "ok"],

  setup(props, { emit }) {
    const isOpen = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    const onCancel = () => {
      emit("cancel");
    };

    const onOk = () => {
      emit("ok");
    };

    const selectedTab = ref(0);

    const taskNotificationCount = computed(() => SMNotifications.taskNotificationCount);

    const router = getCurrentInstance()?.proxy?.$router;

    async function openNotifications() {
      onCancel();

      try {
        await router.push(`${SMUser.basePath}/tasks`);
      } catch {
        return;
      }
    }

    return {
      isOpen,
      onCancel,
      onOk,
      close,
      selectedTab,
      taskNotificationCount,
      openNotifications,
    };
  },
});
